import { Typography } from "@braintrust/braintrust-ui-components";
import type { StripeCreditCardPayment } from "@js/types/payments";

import { PaymentMethodMaskedNumber } from "../../masked-credit-card-number";

import styles from "./styles.module.scss";

type StripeCreditCardProps = {
  paymentMethod: StripeCreditCardPayment;
};

export const StripeCreditCard = ({ paymentMethod }: StripeCreditCardProps) => {
  return (
    <div className={styles.stripeCreditCard}>
      <PaymentMethodMaskedNumber last4={paymentMethod.method.last4} />
      <Typography
        component="p"
        size="small"
        color="grey-2"
        sx={{ textTransform: "uppercase" }}
      >
        Exp: {paymentMethod.method.exp_month}/{paymentMethod.method.exp_year}
      </Typography>
    </div>
  );
};
